import BookStep2 from "components/view/book/step2";
import BookStep4 from "components/view/book/step4";
import { useBookInfContext } from "components/context/bookInfContext";
import BookStep1Page from "./step1";
import Bookstep3Page from "./step3";

export default function BookPage() {
  const { bkStep } = useBookInfContext();

  return (
    <>
      {bkStep === 1 && <BookStep1Page />}
      {bkStep === 2 && <BookStep2 />}
      {bkStep === 3 && <Bookstep3Page />}
      {bkStep === 4 && <BookStep4 />}
    </>
  );
}
